import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

describe('Part', () => {
  describe('From(new)', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          m_part: {},
          new_m_part_field: {m_part_code:{}, m_part_field_options: []},
          new_m_part_field_option: {}
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index is_edit={false}/>);

      await act(() => promise);
      
      const name = screen.getByRole("textbox", {name: "質問名"}) as HTMLInputElement;
      const title = screen.getByRole("textbox", {name: "質問文"}) as HTMLInputElement;
      const display_name = screen.getByRole("textbox", {name: "質問名（患者画面）"}) as HTMLInputElement;
      const description = screen.getByRole("textbox", {name: "質問詳細"}) as HTMLInputElement;
      const radio_1 = screen.getByRole("radio", {name: "新患／再来向け"}) as HTMLInputElement;
      const radio_2 = screen.getByRole("radio", {name: "再来向け"}) as HTMLInputElement;
      const goocoid = screen.getByRole("textbox", {name: "GooCo先確認ID"}) as HTMLInputElement;

      // Valueの確認
      expect(name.value).toBe("");
      expect(display_name.value).toBe("");
      expect(description.value).toBe("");
      expect(title.value).toBe("");
      expect(goocoid.value).toBe("");
      expect(radio_1.value).toBe("false");
      expect(radio_2.value).toBe("true");
      expect(radio_1).toBeChecked();
      expect(radio_2).not.toBeChecked();

      // placeholderの確認
      expect(name.placeholder).toBe("例：患者氏名");
      expect(title.placeholder).toBe("例：お名前は？");
      expect(display_name.placeholder).toBe("例：お名前");
      expect(description.placeholder).toBe("質問詳細を入力してください");
      expect(goocoid.placeholder).toBe("0001");
      

      // ボタン類
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('作成する')).toBeInTheDocument();
      
    });  
  });

  describe('From(edit)', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          m_part: {id: 1, name: "質問1_名称", description: "質問1_詳細", display_web_name: "質問1_表示名", description_web: null, m_company_id: 1, share_range_kbn: 1, is_return_question: false, display_web_short_name: "省略名", gooco_hearing_id: "1234"},
          m_part_fields: []
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index is_edit={true}/>);

      await act(() => promise);
      
      const name = screen.getByRole("textbox", {name: "質問名"}) as HTMLInputElement;
      const title = screen.getByRole("textbox", {name: "質問文"}) as HTMLInputElement;
      const display_name = screen.getByRole("textbox", {name: "質問名（患者画面）"}) as HTMLInputElement;
      const description = screen.getByRole("textbox", {name: "質問詳細"}) as HTMLInputElement;
      const goocoid = screen.getByRole("textbox", {name: "GooCo先確認ID"}) as HTMLInputElement;

      // Valueの確認
      expect(name.value).toBe("質問1_名称");
      expect(display_name.value).toBe("省略名");
      expect(description.value).toBe("質問1_詳細");
      expect(title.value).toBe("質問1_表示名");
      expect(goocoid.value).toBe("1234");

      // placeholderの確認
      expect(name.placeholder).toBe("例：患者氏名");
      expect(title.placeholder).toBe("例：お名前は？");
      expect(display_name.placeholder).toBe("例：お名前");
      expect(description.placeholder).toBe("質問詳細を入力してください");
      expect(goocoid.placeholder).toBe("0001");
      
      // ボタン類
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('更新する')).toBeInTheDocument();
      
    });  
  });
});

